import React, { useEffect, useState } from "react";
import { IntlProvider } from "react-intl";
import { CircularProgress } from "@material-ui/core";
import { useStyles } from "../layouts/layoutStyles";
import flattenObject from "../utils/flattenObject";

const Provider = ({ children }) => {
  const classes = useStyles();

  const [isLoading, setIsLoading] = useState(true);
  const [messages, setMessages] = useState();

  useEffect(() => {
    const loadLanguage = async () => {
      const esMessages = await import("./messages/es");

      setMessages(flattenObject(esMessages.default));
      setIsLoading(false);
    };

    loadLanguage();
  }, []);

  if (isLoading) return <CircularProgress className={classes.loading} />;

  return (
    <IntlProvider locale="es-MX" messages={messages}>
      {children}
    </IntlProvider>
  );
};

export default Provider;
